import CreateStatusPage from './CreateStatusPage';

export default CreateStatusPage;
